import { useCallback } from 'react';
import type { RecommendationReport } from '~/components/ui/widgets/RecommendationReportWidget/pdfGenerator';
import { generateReportPDF } from '~/components/ui/widgets/RecommendationReportWidget/pdfGenerator';

export const useRecommendationReportDownload = (
  portfolioName?: string | null,
) => {
  return useCallback(
    async (report?: RecommendationReport | null) => {
      if (!report) {
        console.warn(
          '[RecommendationReport] No report data available to download.',
        );
        return;
      }

      await generateReportPDF(report, portfolioName || undefined);
    },
    [portfolioName],
  );
};
